import React from 'react';

import LandingLayout from 'layouts/LandingLayout/LandingLayout';

import Flex from 'ui/Flex/Flex';

import HeroSection from './HeroSection/HeroSection';
import ShooseSection from './ShooseSection/ShooseSection';
import PowerfullSection from './PowerfullSection/PowerfullSection';
import PublishSection from './PublishSection/PublishSection';
import TrustedSection from './TrustedSection/TrustedSection';
import TemplatesSection from './TemplatesSection/TemplatesSection';
import Footer from './Footer/Footer';
import CommunitySection from './CommunitySection/CommunitySection';
// import CompareSection from './CompareSection/CompareSection';
import ResourcesSection from './ResourcesSection/ResourcesSection';
import styles from './LandingPage.module.scss';
import Union from '../../assets/landingpage/Union.svg';
import Union2 from '../../assets/landingpage/Union-2.svg';
import Union3 from '../../assets/landingpage/Union-3.svg';

const LandingPage = () => {
  return (
    <LandingLayout>
      <Flex
        direction="column"
        gap="24"
        css={{ marginTop: '20px', marginBottom: '20px' }}
      >
        <HeroSection />
        <ShooseSection />
        <div className={styles.background_container}>
          <img
            src={Union}
            alt="Union"
            className={styles.background_union_image}
            style={{ left: '15px', top: '-210px', width: '240px' }}
          />
        </div>
        <PowerfullSection />
        <PublishSection />
        <TrustedSection />
        <TemplatesSection />
        <div className={styles.background_container}>
          <img
            src={Union2}
            alt="Union2"
            className={styles.background_union_image}
            style={{ right: '0', top: '-530px', width: '500px' }}
          />
        </div>
        <CommunitySection />
        {/* Uncommnent later  */}
        {/* <CompareSection /> */}
        <div className={styles.background_container}>
          <img
            src={Union3}
            alt="Union3"
            className={styles.background_union_image}
            style={{ left: '0', top: '-580px', width: '570px' }}
          />
        </div>
        <ResourcesSection />
        <Footer />
      </Flex>
    </LandingLayout>
  );
};

export default LandingPage;
